export const hasError = (props) =>
  (props.touched || props.submitFailed) && props.invalid

export default { hasError }
